import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Intro from "./pages/Intro";
import AuthProvider from "./AuthProvider";
import "./App.css";
import Services from "./pages/Services";
import Background from "./components/Background";
import Navbar from "./components/Navbar";
import Policies from "./pages/Policies";
import Completion from "./pages/Completion";
import Header from "./components/Header";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Footer from "./components/Footer";

import ReactGA from "react-ga4";
import OpenExternally from "./components/OpenExternally";

// Initialize once
ReactGA.initialize("G-JFTB0373F9");

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};

const RouteTracker = () => {
  usePageTracking();
  return null;
};

const App = () => {

  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <AuthProvider>
      <Router>
        <RouteTracker />
        <Routes>

          {/* ✅ Public Routes */}
          <Route path="/completion" element={<Completion />} />
          <Route path="/OpenExternally" element={<OpenExternally />} />

          {/* Protected Routes - Require Authentication */}
          <Route path="/*" element={<ProtectedApp />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

// Component to Handle Authentication Logic
const ProtectedApp = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const isInstagramBrowser = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    console.log(ua);
    return ua.includes("Instagram");
  };


  if (isLoading) {
    return <h2>Loading...</h2>; // Show a loading state
  }

  if (!isAuthenticated) {
    if (isInstagramBrowser()) {
      return <OpenExternally />
    }
    return <Intro />; // Redirect unauthenticated users to Intro
  }

  return (
    <div className="authenticated">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" />} /> {/* Redirect unknown routes */}
      </Routes>
    </div>
  );
};

export default App;
